<template>
  <div v-lazy-container="{ selector: 'img' }">  <!-- START SECTION BANNER -->
    <b-container class="pt-2" fluid="md">
      <b-row class="text-left">
        <div class="col-lg-4">
          <b-card no-body>
            <b-tabs card fill>
              <b-tab title="NẠP THẺ" active>
                <topup-card-form :website="website"></topup-card-form>
              </b-tab>
              <b-tab title="TOP NẠP THẺ">
                <b-card-text>
                  <b-list-group>
                    <b-list-group-item class="d-flex align-items-center" v-for="(top, index) in topRecharges" :key="index">
                      <b-badge pill variant="danger" class="mr-3">{{ index +1 }}</b-badge>
                      <span class="mr-auto"> {{ top.name }}</span>
                      <b-badge pill variant="warning">{{ Helper.formatMoney(top.total) }} đ</b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
        <div class="col-lg-8">
          <div class="carousel-inner">
            <b-img-lazy :src="website.image_slide"></b-img-lazy>
          </div>
        </div>
      </b-row>
    </b-container>
    <!-- END SECTION BANNER -->
    <!-- END MAIN CONTENT -->
    <div class="main_content pt-5 mt-10">
      <div class="section small_pt pb_20">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="">
                <div class="row text-center">
                  <div class="col-lg-12 col-md-12">
                    <b-row class="justify-content-center">
                      <b-col v-for="catSlide in categories" :key="catSlide.image" class="pr-1 mt-2">
                        <img thumbnail fluid :src="catSlide.image" :alt="catSlide.name"
                             @click="choseCategory(catSlide)">
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- START SECTION SHOP -->
      <div class="section small_pt pb_20 pt-10" :id="targetCategory.slug">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-6">
              <div class="heading_s3 text-center">
                <h2>{{ targetCategory.name }}</h2>
              </div>
              <div class="small_divider clearfix"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-4 col-6" v-for="account_package in targetCategory.packages"
                 :key="account_package.slug">
              <div class="product_box text-center">
                <div class="product_img">
                  <a :href="route('fe.package', { domain: website.domain , package: account_package.slug})">
                    <img :src="account_package.thumbnail" :alt="account_package.name">
                  </a>
                  <div class="product_action_box">
                    <ul class="list_none pr_action_btn">
                      <li><a :href="route('fe.package', { domain: website.domain , package: account_package.slug})"><i
                          class="icon-heart"></i></a></li>
                    </ul>
                  </div>
                </div>
                <div class="product_info">
                  <h6 class="product_title">
                    <a :href="route('fe.package', { domain: website.domain , package: account_package.slug})">{{ account_package.name
                      }}</a>
                  </h6>
                  <div class="product_price">
                    <span
                        class="price">Đã bán: {{ Helper.formatMoney(account_package.sold_account_count + (account_package.created_day_count * 85))
                      }}</span>
                  </div>
                  <div class="rating_wrap">
                    <div class="rating">
                      <div class="product_rate" style="width:70%"></div>
                    </div>
                  </div>
                  <div class="add-to-cart">
                    <a :href="route('fe.package', { domain: website.domain , package: account_package.slug})"
                       class="btn btn-fill-out btn-radius">Xem ngay</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6" v-for="wheel in targetCategory.wheels" :key="wheel.slug">
              <div class="product_box text-center">
                <div class="product_img">
                  <a :href="route('fe.wheel', { domain: website.domain , wheel: wheel.slug})">
                    <img :src="wheel.thumbnail" :alt="wheel.name">
                  </a>
                  <div class="product_action_box">
                    <ul class="list_none pr_action_btn">
                      <li><a :href="route('fe.wheel', { domain: website.domain , wheel: wheel.slug})"><i
                          class="icon-heart"></i></a></li>
                    </ul>
                  </div>
                </div>
                <div class="product_info">
                  <h6 class="product_title"><a :href="route('fe.wheel', { domain: website.domain , wheel: wheel.slug})">{{
                    wheel.name
                    }}</a></h6>
                  <div class="product_price">
                      <span class="regular_price"> {{ Helper.formatMoney(parseFloat(wheel.regular_price.toString())) }}
                            <span v-if="wheel.is_promo == 0"> đ</span>
                            <span v-else-if="wheel.is_promo == 1"> coin</span>
                      </span>
                      <span class="price"> {{ Helper.formatMoney(parseFloat(wheel.price.toString())) }}
                            <span v-if="wheel.is_promo == 0"> đ</span>
                            <span v-else-if="wheel.is_promo == 1"> coin</span>
                      </span>
                  </div>
                  <div class="rating_wrap">
                    <div class="rating">
                      <div class="product_rate" style="width:80%"></div>
                    </div>
                  </div>
                  <div class="add-to-cart">
                    <a :href="route('fe.wheel', { domain: website.domain , wheel: wheel.slug})"
                       class="btn btn-fill-out btn-radius">Chơi ngay</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6" v-for="random in targetCategory.random_prices" :key="random.slug">
              <div class="product_box text-center">
                <div class="product_img">
                  <a @click="handleConfirm(random)">
                    <img :src="random.thumbnail" :alt="random.title">
                  </a>
                  <div class="product_action_box">
                    <ul class="list_none pr_action_btn">
                      <li><a :href="route('fe.view_random_price', { domain: website.domain , random: random.slug})"><i
                          class="icon-heart"></i></a></li>
                    </ul>
                  </div>
                </div>
                <div class="product_info">
                  <h6 class="product_title"><a @click="handleConfirm(random)">{{ random.title }}</a></h6>
                  <div class="product_price">
                      <span class="regular_price">{{ Helper.formatMoney(random.regular_price) }}đ/Lượt</span>
                      <span class="price">{{ Helper.formatMoney(random.price) }}đ/Lượt</span>
                  </div>
                  <div class="rating_wrap">
                    <div class="rating">
                      <div class="product_rate" style="width:80%"></div>
                    </div>
                  </div>
                  <div class="add-to-cart">
                    <a :href="route('fe.view_random_price', { domain: website.domain , random: random.slug})"
                       class="btn btn-fill-out btn-radius">Chơi Ngay</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6" v-for="lucky_box in targetCategory.lucky_boxs" :key="lucky_box.slug">
              <div class="product_box text-center">
                <div class="product_img">
                  <a :href="route('fe.luckyBox.detail', { domain: website.domain, slug: lucky_box.slug })">
                    <img :src="lucky_box.thumbnail" :alt="lucky_box.name">
                  </a>
                  <div class="product_action_box">
                    <ul class="list_none pr_action_btn">
                      <li><a :href="route('fe.luckyBox.detail', { domain: website.domain, slug: lucky_box.slug })"><i
                          class="icon-heart"></i></a></li>
                    </ul>
                  </div>
                </div>
                <div class="product_info">
                  <h6 class="product_title"><a
                      :href="route('fe.luckyBox.detail', { domain: website.domain, slug: lucky_box.slug })">{{
                    lucky_box.name
                    }} </a></h6>
                  <div class="product_price">
                      <span class="regular_price">{{ Helper.formatMoney(lucky_box.regular_price) }}
                            <span v-if="lucky_box.is_promo == 0"> đ / Lượt</span>
                            <span v-else-if="lucky_box.is_promo == 1"> coin / Lượt</span>
                      </span>
                    <span class="price">{{ Helper.formatMoney(lucky_box.price) }}
                            <span v-if="lucky_box.is_promo == 0"> đ / Lượt</span>
                            <span v-else-if="lucky_box.is_promo == 1"> coin / Lượt</span>
                    </span>
                  </div>
                  <div class="rating_wrap">
                    <div class="rating">
                      <div class="product_rate" style="width:87%"></div>
                    </div>
                  </div>
                  <div class="add-to-cart">
                    <a :href="route('fe.luckyBox.detail', { domain: website.domain, slug: lucky_box.slug })"
                       class="btn btn-fill-out btn-radius">
                      Chơi Ngay</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END SECTION SHOP -->
    </div>
  </div>
</template>

<script>
import DepositViaAtm from "../v2/DepositViaAtm";
import TopupCardForm from "./TopupCardForm";

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: {DepositViaAtm, TopupCardForm},
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      }
    },
    categories: {
      Type: Object,
      default() {
        return {};
      }
    },
    category: {
      Type: Object,
      default() {
        return {};
      }
    },
    website: {
      Type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      topRecharges: {},
      targetCategory: this.category
    }
  },
  mounted() {
    this.getTopRecharge();
    if (this.website.notify_status === 'on') {
      this.$swal.fire({
        title: 'Thông báo',
        width: 700,
        customClass: 'swal-notify',
        html: this.website.notification
      });
    }
  },
  methods: {
    formatMoney(money) {
      return this.Helper.formatNumber(money);
    },
    async getTopRecharge() {
      try {
        const uri = this.route('fe_top_recharge', {domain: this.website.domain});
        const response = await this.Request.get(uri);
        this.topRecharges = response.data;
      } catch (e) {
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: this._.isEmpty(errorMessages) ? e.response.data.error : errorMessages[0],
        });
      }
    },
    async handleBuyRandomAccount(price) {
      try {
        const uri = this.route('fe_buy_random', {domain: this.website.domain});
        const response = await this.Request.post(uri, {price: price.id});
        console.log(response);
        if (response.data.status === false) {
          await this.$swal.fire({
            title: 'Có lỗi xảy ra!',
            text: response.data.message,
            icon: 'error'
          });
        } else {
          await this.$swal.fire({
                icon: 'success',
                title: 'Thành Công',
                html: response.data.message,
              }
          );
        }
      } catch (e) {
        console.log(e); // eslint-disable-line
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: this._.isEmpty(errorMessages) ? e.response.data.error : errorMessages[0],
        });
      }
    },
    async handleConfirm(price) {
      await this.$swal.fire({
        title: 'Bạn có muốn thử vận may?',
        imageUrl: price.thumbnail,
        html: price.content,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Thử ngay`,
        denyButtonText: `Huỷ`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleBuyRandomAccount(price);
        }
      })
    },
    choseCategory(category) {
      this.targetCategory = this._.clone(category);
      if (window.history.replaceState) {
        //prevents browser from storing history with each change:
        document.title = this.targetCategory.name;

        window.history.replaceState("", "", this.route('fe_cat', {
          domain: this.website.domain,
          category: this.targetCategory.slug
        }));
      }
    }
  }
}
</script>
